import moment from 'moment';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    Col,
    Row,
    Table,
} from 'reactstrap';

import RouteMap from './RouteMap';

const RouteShipmentDetails = ({
    freight,
    t,
}) => {
    const details = [
        { label: 'Freight ID', value: freight.reference },
        { label: 'Cargo type', value: t(freight.cargo.type) },
        { label: 'Weight', value: `${freight.cargo.weight.toLocaleString('en-US')} ${t('kg')}` },
        { label: 'Transport type', value: t(freight.transportType) },
        { label: 'Pickup date', value: moment(freight.pickupDate).format('MMM D, YYYY') },
        { label: 'Delivery date', value: moment(freight.deliveryDate).format('MMM D, YYYY') },
        { label: 'Pickup location', value: freight.pickupLocation },
        { label: 'Delivery location', value: freight.deliveryLocation },
        { label: 'Special requirements', value: freight.specialRequirements },
    ];

    return (
        <Card className="h-100">
            <CardBody>
                <h5 className="mb-3">{t('Route & Shipment Details')}</h5>

                <Row>
                    <Col lg="7">
                        <RouteMap
                            destination={freight.route.destination}
                            origin={freight.route.origin}
                        />
                    </Col>

                    <Col lg="5">
                        <Table borderless className="mb-0 freight-details-table" size="sm">
                            <tbody>
                                {details.map((detail) => (
                                    <tr key={detail.label}>
                                        <th>{t(detail.label)}</th>
                                        <td>{detail.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    RouteShipmentDetails
);
